module.exports = __webpack_public_path__ + "static/media/new-york-55.b59f0085.jpg";